import { render } from "./ModalForm.vue?vue&type=template&id=1395ec7a&scoped=true"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"

import "./ModalForm.vue?vue&type=style&index=0&id=1395ec7a&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1395ec7a"]])

export default __exports__